<ng-template #template let-modal>
    <div class="product-modal-shell">
        <div class="product-modal-shell__topline"></div>

        <div class="product-modal-shell__header">
            <div>
                <p class="eyebrow">{{ t('heading-title.product-detail', 'Product Detail') }}</p>
                <h3 class="product-title">{{ product.name || t('label-title.product', 'Product') }}</h3>
                <p class="product-subtitle">{{ categoryName || t('label-title.category', 'Category') }}</p>
            </div>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>

        <div class="product-modal-shell__body row g-4">
            <div class="col-xl-6">
                <div class="visual-card">
                    <div class="visual-card__hero image-watermark-wrapper">
                        <img
                            [src]="helper.getImageSrc(displayImage, helper.DEFAULT_LOGO)"
                            class="visual-card__image"
                            alt="product image"
                            (error)="helper.handleProductImageError($event)"
                        />
                        <div class="visual-card__badge" *ngIf="hasDiscount">
                            {{ product.discount }}% {{ t('label-title.discount', 'Discount') }}
                        </div>
                    </div>

                    <div class="thumb-strip" *ngIf="allImages.length > 1">
                        @for(image of allImages; track $index){
                        <button
                            type="button"
                            class="thumb-strip__item"
                            [class.is-active]="selectedImage === image"
                            (click)="selectImage(image)"
                            aria-label="Select product image"
                        >
                            <img
                                [src]="helper.getImageSrc(image, helper.DEFAULT_LOGO)"
                                alt="thumbnail"
                                (error)="helper.handleProductImageError($event)"
                            />
                        </button>
                        }
                    </div>
                </div>
            </div>

            <div class="col-xl-6">
                <div class="details-stack">
                    <div class="quick-stats">
                        <div class="stat-pill">
                            <span>{{ t('label-title.category', 'Category') }}</span>
                            <strong>{{ categoryName || '-' }}</strong>
                        </div>
                        <div class="stat-pill stat-pill--soft">
                            <span>{{ t('label-title.quantity', 'Quantity') }}</span>
                            <strong>{{ product.quantity }}</strong>
                        </div>
                        <div class="stat-pill stat-pill--warm" *ngIf="hasDiscount">
                            <span>{{ t('label-title.discount', 'Discount') }}</span>
                            <strong>{{ product.discount }}%</strong>
                        </div>
                    </div>

                    <section class="price-panel">
                        <div class="price-panel__label">{{ t('label-title.price', 'Price') }}</div>
                        <div class="price-panel__value">
                            <span class="price-panel__current">
                                {{ helper.currency }} {{ hasDiscount ? (discountedPrice | number: '1.0-0') : (product.price | number: '1.0-0') }}
                            </span>
                            <span class="price-panel__original" *ngIf="hasDiscount">
                                {{ helper.currency }} {{ product.price | number: '1.0-0' }}
                            </span>
                        </div>
                        <div class="price-panel__note">{{ t('validation-title.cash-on-delivery-only', 'Cash on delivery only. Payment starts as unpaid.') }}</div>
                    </section>

                    <section class="order-panel">
                        <div class="order-panel__head">
                            <div>
                                <h4>{{ t('label-title.order-quantity', 'Order Quantity') }}</h4>
                                <p>{{ t('validation-title.order-quantity-at-least-one', 'Quantity must be at least 1.') }}</p>
                            </div>
                        </div>

                        <div class="order-panel__controls">
                            <div class="stepper">
                                <button type="button" class="stepper__btn" (click)="decreaseQuantity()">-</button>
                                <input
                                    type="number"
                                    class="stepper__input"
                                    [(ngModel)]="orderQuantity"
                                    min="1"
                                    [max]="product.quantity"
                                />
                                <button type="button" class="stepper__btn" (click)="increaseQuantity()">+</button>
                            </div>

                            <button type="button" class="cta-button" [disabled]="isAddingToCart" (click)="addToCart()">
                                {{ isAddingToCart ? (t('button-title.placing', 'Placing...')) : (t('button-title.add-to-cart', 'Add to Cart')) }}
                            </button>
                        </div>
                    </section>

                    <section class="story-card">
                        <h4>{{ t('label-title.description', 'Description') }}</h4>
                        <p>{{ product.description }}</p>
                    </section>

                    <section class="notify-card">
                        <p>
                            {{ t('label-title.if-you-like-this-product-then', 'If you like this product then') }}
                            <button type="button" class="notify-link" (click)="notifyProduct()">
                                {{ t('label-title.notify', 'Notify') }}
                            </button>
                            {{ t('label-title.admin', 'Admin') }}.
                        </p>
                    </section>
                </div>
            </div>
        </div>
    </div>
</ng-template>
